import {
  updateSearchWidgetSwapSourceDestination,
  setCommonFareRulesData,
  updateSrpErrMsg,
  updateThorData,
  insertMSEFlights,
  updateSourceDestination
} from './actions';

import {
  searchWidgetSourceSelector,
  searchWidgetDestinationSelector,
  commonFareRulesRequestSelector,
  dataIndexSelector,
  unorderedChunksLengthSelector,
  filterMinMaxSelector,
  showOnePaxPriceSelector,
  sourceSelector,
  destinationSelector,
  departureSelector,
  arrivalSelector,
  onwardFlightsSelector,
  displayInfoSelector,
  returnFlightsSelector,
  totalPaxSelector,
  journeyTypeSelector,
  travelTypeSelector,
  directlyLandedSelector
} from './selectors';

import {
  getFilterMinMaxValues,
  createDisplayFlights,
  formatFlightForDisplay,
  parseDomesticRoundTripDiscounts,
  getTempSrcDestObj
} from '../../utils/filterUtils';

import { baggageDataAndFareRulesAPI, getFareOptionsServer } from '@ibibo/hulk-apis';
import sendDataToNewrelic from '@stencil/send-data-to-new-relic';

export const swapSearchWidgetSoureDestinationThunk = () => {
  return (dispatch, getState) => {
    const source = searchWidgetSourceSelector(getState());
    const destination = searchWidgetDestinationSelector(getState());

    dispatch(
      updateSearchWidgetSwapSourceDestination({
        source: destination,
        destination: source
      })
    );
  };
};

export function getBaggageDataAndFareRulesSRP(flightItem, type = 'onward') {
  return function (dispatch, getState) {
    const { seo } = getState();
    const { onwardFlights } = seo;
    const selectedFlight = onwardFlights[flightItem.originalIndex];
    const flightID = flightItem.id;

    const params = commonFareRulesRequestSelector(getState());
    params.bjson.o = selectedFlight;

    Object.keys(params).forEach(key => {
      params[key] = JSON.stringify(params[key]);
    });

    baggageDataAndFareRulesAPI(params, () => {})
      .then(response => {
        dispatch(setCommonFareRulesData({ id: flightID, data: response }));
      })
      .catch(err => {});
  };
}

export const getFareOptionsDetails = async (flavour = 'mobile') => {
  const response = await getFareOptionsServer(flavour);
  const isMobile = flavour === 'mobile' ? true : false;
  if (response.content) {
    const fareOptions = JSON.parse(response.content);
    if (isMobile) {
      return fareOptions;
    }
    const fareOptionsArray = Object.keys(fareOptions).map(key => {
      return fareOptions[key];
    });
    const sortedFareOptions = fareOptionsArray.sort(function (a, b) {
      return a.priority - b.priority;
    });
    return sortedFareOptions;
  }
  return null;
};

export function createMSEFlightList(mseList) {
  return function (dispatch, getState) {
    try {
      const onwardFlights = onwardFlightsSelector(getState());
      let filterMinMaxValues = JSON.parse(JSON.stringify(filterMinMaxSelector(getState())));
      const {
        refundability,
        airports,
        carriers,
        dates,
        messageText,
        messageValues,
        discountFares,
        discountMessages,
        showOnePaxPrice
      } = displayInfoSelector(getState());
      const newMseFlights = {};
      const newMseDisplayFlights = {};
      mseList.forEach(mse => {
        const updateIndex = mse.ui;
        const updateFlight = mse.uf;
        const replaceIndex = mse.r;
        let onwardFlight;
        if (newMseFlights[updateIndex]) {
          onwardFlight = [...newMseFlights[updateIndex][updateIndex]];
        } else {
          onwardFlight = [...onwardFlights[updateIndex]];
        }
        if (replaceIndex === -1) {
          onwardFlight.push({ ...updateFlight, originalIndex: updateIndex });
        } else {
          if (updateFlight === null) {
            onwardFlight.splice(replaceIndex, 1);
          } else {
            onwardFlight.splice(replaceIndex, 1, { ...updateFlight, originalIndex: updateIndex });
          }
        }
        // check for filterminmax values
        onwardFlight.forEach(flightItem => {
          const price = flightItem[5]
            ? flightItem[5]
            : showOnePaxPrice
            ? flightItem.p1
            : flightItem.p;
          filterMinMaxValues = getFilterMinMaxValues(
            flightItem,
            filterMinMaxValues,
            'onward',
            price,
            updateIndex
          );
        });
        const displayFlight = formatFlightForDisplay({
          flightList: onwardFlight,
          refundabilityArr: refundability,
          airportsArr: airports,
          carriersArr: carriers,
          datesArr: dates,
          textArr: messageText,
          valueArr: messageValues,
          discountFares,
          discountMessages,
          originalIndex: updateIndex,
          showOnePaxPrice
        });
        newMseFlights[updateIndex] = { [updateIndex]: onwardFlight };
        newMseDisplayFlights[updateIndex] = { [updateIndex]: displayFlight };
      });
      const newMseFlightsArr = Object.entries(newMseFlights).map(([key, value]) => {
        return value;
      });
      const newMseDisplayFlightsArr = Object.entries(newMseDisplayFlights).map(([key, value]) => {
        return value;
      });
      dispatch(
        insertMSEFlights({
          onwardFlights: newMseFlightsArr,
          displayOnwardFlights: newMseDisplayFlightsArr,
          filterMinMaxValues
        })
      );
    } catch (err) {
      sendDataToNewrelic('CreateMSEFlightList', `Failed with error: ${err}`);
    }
  };
}

export function domesticRoundTripDiscountThunk(discounts) {
  return function (dispatch, getState) {
    try {
      const onwardFlights = onwardFlightsSelector(getState());
      const returnFlights = returnFlightsSelector(getState());
      const showOnePaxPrice = showOnePaxPriceSelector(getState());
      const totalPax = totalPaxSelector(getState());
      let filterMinMaxValues = JSON.parse(JSON.stringify(filterMinMaxSelector(getState())));
      Object.keys(discounts.onwardDiscounts).forEach(key => {
        const index = parseInt(key);
        const discountObj = discounts.onwardDiscounts[index];
        const onwardFlight = onwardFlights[index][0];
        discounts.onwardDiscounts[index].carrier = onwardFlight.f[0].c;
        const price = onwardFlight[5]
          ? onwardFlight[5] - discountObj.discount
          : showOnePaxPrice
          ? Math.round(onwardFlight.p1 - discountObj.discount / totalPax)
          : onwardFlight.p - discountObj.discount;
        filterMinMaxValues = getFilterMinMaxValues(
          onwardFlight,
          filterMinMaxValues,
          'onward',
          price,
          index
        );
      });
      Object.keys(discounts.returnDiscounts).forEach(key => {
        const index = parseInt(key);
        const discountObj = discounts.returnDiscounts[index];
        const returnFlight = returnFlights[index][0];
        discounts.returnDiscounts[index].carrier = returnFlight.f[0].c;
        const price = returnFlight[5]
          ? returnFlight[5] - discountObj.discount
          : showOnePaxPrice
          ? Math.round(returnFlight.p1 - discountObj.discount / totalPax)
          : returnFlight.p - discountObj.discount;
        filterMinMaxValues = getFilterMinMaxValues(
          returnFlight,
          filterMinMaxValues,
          'return',
          price,
          index
        );
      });
    } catch (err) {
      sendDataToNewrelic('DomesticRoundTripDiscountThunk', `Failed with error: ${err}`);
    }
  };
}

export function parseData(chunk) {
  return function (dispatch, getState) {
    try {
      //Don't remove
      console.log('PARSE DATA ', chunk['o'].length);

      const dataIndex = dataIndexSelector(getState());
      const unorderedChunksForNoOfLoops = unorderedChunksLengthSelector(getState());
      const numberOfRunsOfTheLoop = dataIndex + unorderedChunksForNoOfLoops + 1;

      let onwardMaxPrice = 0;
      let onwardMinPrice = Infinity;
      let returnMaxPrice = 0;
      let returnMinPrice = Infinity;
      let onwardDuration = { min: Infinity, max: 0 };
      let returnDuration = { min: Infinity, max: 0 };

      if (chunk && chunk.client_err) {
        dispatch(updateSrpErrMsg(chunk.client_err));
        return;
      }

      for (let chunkIndex = dataIndex; chunkIndex < numberOfRunsOfTheLoop; chunkIndex++) {
        if (!chunk.n) {
          break;
        }

        const onwardFlightsLength = 0;
        const returnFlightsLength = 0;
        const alternateTimeFlightsLength = 0;
        const alternateLocationFlightsLength = 0;

        let filterMinMaxValues = JSON.parse(JSON.stringify(filterMinMaxSelector(getState())));
        const showOnePaxPrice =
          chunk['pa'] && chunk['pa'].toLowerCase().indexOf('onepax') > -1 ? true : false;

        const onwardFlights = chunk['o']
          ? chunk['o'].map((item, index) => {
              const showOnePaxPriceFromSelector = showOnePaxPriceSelector(getState());
              const onePaxOrNot = dataIndex === 0 ? showOnePaxPrice : showOnePaxPriceFromSelector;
              const price = item[5] ? item[5] : onePaxOrNot ? item.p1 : item.p;
              const duration = item.t;

              if (price > onwardMaxPrice) {
                onwardMaxPrice = price;
              }
              if (price < onwardMinPrice) {
                onwardMinPrice = price;
              }
              if (duration > onwardDuration.max) {
                onwardDuration.max = duration;
              }
              if (duration < onwardDuration.min) {
                onwardDuration.min = duration;
              }

              if (item.r && item.r.t) {
                // For INT RT
                const returnTime = item.r.t;
                if (returnTime > returnDuration.max) {
                  returnDuration.max = returnTime;
                }
                if (returnTime < returnDuration.min) {
                  returnDuration.min = returnTime;
                }
              }

              filterMinMaxValues = getFilterMinMaxValues(
                item,
                filterMinMaxValues,
                'onward',
                price,
                onwardFlightsLength + index
              );
              return [item];
            })
          : [];

        const returnFlights = chunk['r']
          ? chunk['r'].map((item, index) => {
              const showOnePaxPriceFromSelector = showOnePaxPriceSelector(getState());
              const onePaxOrNot = dataIndex === 0 ? showOnePaxPrice : showOnePaxPriceFromSelector;
              const price = item[5] ? item[5] : onePaxOrNot ? item.p1 : item.p;
              const duration = item.t;

              if (price > returnMaxPrice) {
                returnMaxPrice = price;
              }
              if (price < returnMinPrice) {
                returnMinPrice = price;
              }
              if (duration > returnDuration.max) {
                returnDuration.max = duration;
              } else if (duration < returnDuration.min) {
                returnDuration.min = duration;
              }

              filterMinMaxValues = getFilterMinMaxValues(
                item,
                filterMinMaxValues,
                'return',
                price,
                returnFlightsLength + index
              );
              return [item];
            })
          : [];

        const airports = chunk['a'] || [];
        const carriers = chunk['c'] || [];
        const aircrafts = chunk['e'] || [];
        const refundability = chunk['w'] || [];
        const dates = chunk['d'] || [];
        const ibp = chunk['i'] || [];
        const messageText = chunk['mt'] || [];
        const messageValues = chunk['mv'] || [];
        const messageIcons = chunk['mi'] || [];
        const discountFares = chunk['df'] || [];
        const discountNames = chunk['dn'] || [];
        const discountMessages = chunk['dm'] || [];
        const paVal = chunk['pa'] || '';

        const alternateTimeFlights = chunk['do']
          ? chunk['do'].map((item, index) => [
              { ...item, originalIndex: alternateTimeFlightsLength + index, alternateTime: true }
            ])
          : [];
        const alternateLocationFlights = chunk['co']
          ? chunk['co'].map((item, index) => [
              {
                ...item,
                originalIndex: alternateLocationFlightsLength + index,
                alternateLocation: true
              }
            ])
          : [];
        // const oldDisplayInfo = displayInfoSelector(getState());
        const newDisplayInfo = {
          refundabilityArr: [...refundability],
          airportsArr: [...airports],
          carriersArr: [...carriers],
          datesArr: [...dates],
          textArr: [...messageText],
          valueArr: [...messageValues],
          iconArr: [...messageIcons],
          discountFares: [...discountFares],
          discountMessages: [...discountMessages],
          showOnePaxPrice
        };
        const newDisplayOnwardFlights =
          onwardFlights.length > 0
            ? createDisplayFlights(onwardFlights, newDisplayInfo, onwardFlightsLength)
            : [];
        const newDisplayReturnFlights =
          returnFlights.length > 0
            ? createDisplayFlights(returnFlights, newDisplayInfo, returnFlightsLength)
            : [];

        let newDisplayAlternateTimeFlights = [];
        if (alternateTimeFlights.length > 0) {
          const source = sourceSelector(getState());
          const destination = destinationSelector(getState());
          const departure = departureSelector(getState());
          const arrival = arrivalSelector(getState());
          newDisplayAlternateTimeFlights = createDisplayFlights(
            alternateTimeFlights,
            { ...newDisplayInfo, source, destination, departure, arrival },
            alternateTimeFlightsLength
          );
        }
        let newDisplayAlternateLocationFlights = [];
        if (alternateLocationFlights.length > 0) {
          const source = sourceSelector(getState());
          const destination = destinationSelector(getState());
          newDisplayAlternateLocationFlights = createDisplayFlights(
            alternateLocationFlights,
            { ...newDisplayInfo, source, destination },
            alternateLocationFlightsLength
          );
        }
        const brandIds = chunk['bi'] || [];
        const brandNames = chunk['bn'] || [];
        const terminalInfo = chunk['t'] || [];
        const multiIndex = chunk['m'] || [];
        const promotionText = chunk['px'] || [];
        const similarFlights = chunk['s'] || [];
        const discounts = chunk['g'] || {};

        dispatch(
          updateThorData({
            chunk,
            onwardFlights,
            returnFlights,
            airports,
            carriers,
            aircrafts,
            dates,
            ibp,
            refundability,
            messageText,
            messageValues,
            messageIcons,
            discountFares,
            discountNames,
            discountMessages,
            displayOnwardFlights: newDisplayOnwardFlights,
            displayReturnFlights: newDisplayReturnFlights,
            filterMinMaxValues,
            ...(brandIds.length > 0 ? { brandIds } : null),
            ...(brandNames.length > 0 ? { brandNames } : null),
            ...(terminalInfo.length > 0 ? { terminalInfo } : null),
            ...(multiIndex.length > 0 ? { multiIndex } : null),
            ...(promotionText.length > 0 ? { promotionText } : null),
            ...(similarFlights.length > 0 ? { similarFlights } : null),
            ...(Object.keys(discounts).length > 0 ? { discounts } : null),
            ...(alternateTimeFlights.length > 0 ? { alternateTimeFlights } : null),
            ...(alternateLocationFlights.length > 0 ? { alternateLocationFlights } : null),
            ...(newDisplayAlternateTimeFlights.length > 0
              ? { displayAlternateTimeFlights: newDisplayAlternateTimeFlights }
              : null),
            ...(newDisplayAlternateLocationFlights.length > 0
              ? { displayAlternateLocationFlights: newDisplayAlternateLocationFlights }
              : null),
            ...(showOnePaxPrice ? { showOnePaxPrice } : null),
            ...(paVal ? { paVal } : null),
            onwardMaxPrice,
            onwardMinPrice,
            onwardDuration,
            returnMaxPrice,
            returnMinPrice,
            returnDuration
          })
        );
        if (chunk.fc && chunk.fc.length > 0) {
          dispatch(createMSEFlightList(chunk.fc));
        }
        if (chunk['g']) {
          const parsedDiscounts = parseDomesticRoundTripDiscounts(chunk['g']);
          dispatch(domesticRoundTripDiscountThunk(parsedDiscounts));
          // dispatch(getDiscountMap());
        } else {
          const journeyType = journeyTypeSelector(getState());
          const travelType = travelTypeSelector(getState());
          const isDomRt = journeyType === 'rt' && travelType === 'domestic';
          if (isDomRt) {
            // dispatch(domesticRoundTripComboThunk());
          }
        }
        const directlyLanded = directlyLandedSelector(getState());
        if (directlyLanded.isDirectlyLanded) {
          const source = sourceSelector(getState());
          const destination = destinationSelector(getState());
          const queryArr = directlyLanded.params[0].split('-');
          let newSource = null;
          if (!source.ct) {
            if (chunk.a) {
              newSource = getTempSrcDestObj(chunk.a, queryArr['0']);
            }
          }
          let newDestination = null;
          if (!destination.ct) {
            if (chunk.a) {
              newDestination = getTempSrcDestObj(chunk.a, queryArr['1']);
            }
          }
          if (newSource || newDestination) {
            dispatch(
              updateSourceDestination({
                ...(newSource ? { source: newSource } : null),
                ...(newDestination ? { destination: newDestination } : null)
              })
            );
          }
        }
      }
    } catch (err) {
      sendDataToNewrelic('ParseChunks', `Failed with error: ${err}`);
    }
  };
}
